<template>
  <div>
    <base-header class="header pb-8 pt-5 pt-lg-8 d-flex align-items-center">
      <!-- Mask -->
      <span class="mask opacity-8"></span>
      <!-- Header container -->
      <div class="container-fluid d-flex align-items-center">
        <div class="row">
          <div class="col-12 mt-0 mt-md-4 mt-lg-0 d-block">
            <router-link
              :to="'/colaborador/desafios'"
              class="btn-link font-weight-normal text-white"
              title="Voltar para a listagem de desafios"
              ><i class="fas fa-chevron-left mr-1"></i> Voltar</router-link
            >
          </div>
          <div class="col-lg-7 col-md-10">
            <p class="text-white mt-3 mb-5">
              Aqui você pode avaliar uma tarefa e, se necessário, atualizar as
              avaliações submetidas. Por favor, avalie corretamente a tarefa.
            </p>
          </div>
        </div>
      </div>
    </base-header>

    <div class="container-fluid mt--7">
      <div class="row">
        <div class="col-lg-7 order-1 order-lg-0">
          <card shadow>
            <div slot="header" class="bg-white border-0">
              <div class="row align-items-center">
                <div class="col-8">
                  <h3 class="mb-0" v-show="task.title">
                    {{ task.title }}
                  </h3>
                </div>
              </div>
            </div>
            <template>
              <div class="col-12 vld-parent" ref="left_card">
                <div>
                  <h4 class="heading-small text-muted mb-2">
                    Instruções de submissão
                  </h4>
                  <div class="col-12 tr-container-read-only">
                    <quill-editor
                      v-model="task.submit_instruction"
                      :options="editorReadOnly"
                      disabled="disabled"
                    >
                    </quill-editor>
                  </div>
                </div>
                <hr class="my-3" />
                <h4 class="heading-small text-muted mb-2">Resposta</h4>
                <div class="col-lg-12 tr-container-read-only">
                  <quill-editor
                    v-model="task_submission.submission"
                    :options="editorReadOnly"
                    disabled="disabled"
                  >
                  </quill-editor>
                  <div class="col-lg-12">
                    <base-input
                      type="number"
                      label="Nota numérica da tarefa*"
                      placeholder="Insira uma nota de 1 a 10"
                      v-model="model.evaluation_score"
                    />
                  </div>
                  <div class="col-lg-12">
                    <base-input label="Anotações da sua avaliação">
                      <textarea
                        rows="2"
                        class="form-control"
                        placeholder="Insira anotações que auxiliem a entender sua avaliação"
                        v-model="model.evaluation_note"
                      >
                      </textarea>
                    </base-input>
                  </div>
                  <div
                    v-if="isUpdate"
                    class="text-muted text-sm text-right mt-4"
                  >
                    avaliada em:
                    {{ formatDate(task_submission.created_at, "L") }}. Última
                    atualização em:
                    {{ formatDate(task_submission.updated_at, "L") }}.
                  </div>
                  <div v-else class="text-muted text-sm text-right mt-4">
                    A tarefa ainda não foi avaliada.
                  </div>
                </div>
                <div class="col-12 text-center">
                  <hr class="my-4" />
                  <base-alert type="danger text-center" v-if="error">
                    {{ error }}
                  </base-alert>
                  <base-button
                    :custom="true"
                    type="primary"
                    @click="handleSubmit"
                    >{{ getButtonText }}</base-button
                  >
                </div>
              </div>
            </template>
          </card>
        </div>
        <div class="col-lg-5 mb-5 mb-lg-0 mt-5 mt-lg-0">
          <card shadow bodyClasses="pb-1">
            <div slot="header" class="bg-white border-0">
              <div class="row align-items-center">
                <div class="col-12">
                  <h3 class="mb-0">Desafio</h3>
                </div>
              </div>
            </div>
            <template>
              <div class="col-12">
                <div class="row">
                  <img
                    class="mx-auto d-block img-fluid mb-4"
                    :src="defaultLogo"
                    width="120"
                  />
                </div>
                <div class="row vld-parent" ref="right_card">
                  <div class="col-12">
                    <span class="task-card">
                      <div>
                        <div class="h4 ml-2">
                          {{ task.title }}
                        </div>
                        <div v-show="task.description" class="pb-2">
                          <hr class="my-3" />
                          <div class="col-12 tr-container-read-only">
                            <quill-editor
                              v-model="task.description"
                              :options="editorReadOnly"
                              disabled="disabled"
                            >
                            </quill-editor>
                          </div>
                        </div>
                      </div>
                    </span>
                    <p class="text-right text-xs">
                      <i class="fas fa-info-circle mr-1"></i> Esta tarefa foi
                      aberta em {{ formatDate(task.start_date, "L") }}.
                    </p>
                    <hr class="my-4" />
                    <div>
                      <p v-if="task.end_date" class="text-center mb-2">
                        <i class="far fa-calendar-alt mr-1"></i>
                        O prazo de envio da tarefa é
                        <span class="d-block text-sm text-center mt-2">
                          <span
                            class="
                              bg-white
                              text-dark
                              rounded
                              border
                              px-2
                              py-2
                              font-weight-600
                            "
                            >{{ formatDate(task.end_date, "L") }}</span
                          ></span
                        >
                      </p>

                      <hr class="my-4" />
                      <div class="row text-sm">
                        <div class="col-12 text-center">
                          <p v-if="isUpdate">
                            <i
                              class="text-success fas fa-clipboard-check mr-1"
                            ></i>
                            Você já avaliou a tarefa.
                          </p>
                          <p v-else>
                            <i class="text-danger fas fa-clipboard mr-1"></i>
                            Você ainda não avaliou a tarefa.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </card>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";

import { quillEditor } from "vue-quill-editor";

import api from "@/services/api";

export default {
  name: "tasks_list",
  components: {
    quillEditor
  },
  data() {
    return {
      model: {
        evaluation_score: "",
        evaluation_note: ""
      },
      task_submission: {},
      editorEdittable: {
        placeholder:
          "Digite aqui... (lembre-se, se necessário, você pode linkar arquivos pelo editor)"
      },
      editorReadOnly: {
        placeholder: "N/A",
        readOnly: true,
        theme: "bubble"
      },
      task: "",
      batch: "",
      isUpdate: false,
      error: ""
    };
  },
  async mounted() {
    const leftCard = this.$loading.show({
      container: this.$refs.left_card,
      width: 90,
      height: 90
    });
    const rightCard = this.$loading.show({
      container: this.$refs.right_card,
      width: 90,
      height: 90
    });
    try {
      await this.loadTask();
      leftCard.hide();
      rightCard.hide();
    } catch (e) {
      this.$toasted.error("Ocorreu um erro ao recuperar a tarefa");
    }
  },
  methods: {
    async loadTask() {
      const {
        data: { task, submission }
      } = await api.get(
        `/collaborator/challenges/${this.$route.params.id}/evaluator/tasks/${this.$route.params.equipeId}/${this.$route.params.taskId}`
      );
      this.task = task;
      if (submission) {
        if (submission.evaluation_score) this.isUpdate = true;
        this.task_submission = submission;
        if (submission.evaluation_note)
          this.model.evaluation_note = submission.evaluation_note;
        if (submission.evaluation_score)
          this.model.evaluation_score = submission.evaluation_score;
      }
    },
    async handleSubmit() {
      this.error = "";
      if (!this.model.evaluation_score) {
        this.error = "Por favor, preencha o campo de resposta textual.";
        return;
      }
      const leftCard = this.$loading.show({
        container: this.$refs.left_card,
        width: 90,
        height: 90
      });
      try {
        await api.patch(
          `/collaborator/challenges/${this.$route.params.id}/evaluator/tasks/${this.$route.params.equipeId}/submission/${this.$route.params.taskId}`,
          this.model
        );
        this.$toasted.show("Resposta salva com sucesso");
        this.$router.push(
          `/colaborador/desafios/${this.$route.params.id}/avaliador/equipes/${this.$route.params.equipeId}/tarefas`
        );
      } catch (e) {
        const strError = "Ocorreu um erro ao salvar a resposta";
        const hasErrorMessage =
          e.response && e.response.data && e.response.data.message;
        this.error = hasErrorMessage ? e.response.data.message : strError;
        this.$toasted.error(strError);
      }
      leftCard.hide();
    }
  },
  computed: {
    getButtonText() {
      return this.isUpdate ? "Atualizar avaliação" : "Salvar avaliação";
    },
    defaultLogo() {
      let logoFile = "LOGO_PIC.png";
      if (window.location.host.includes("cobusiness"))
        logoFile = "cobusiness.png";
      else if (window.location.host.includes("sislimpa"))
        logoFile = "sislimpa.png";
      else if (window.location.host.includes("genius")) logoFile = "genius.png";

      return `/img/brand/${logoFile}`;
    }
  }
};
</script>
<style lang="scss" scoped>
.task-card {
  margin: 0;
  padding: 1.5rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.25;
  color: #32325d;
  background-color: #f6f9fc;
  border-radius: 0.375rem;
  border: 0;
  display: inline-block;
  vertical-align: middle;
  width: 100%;
  margin: 0.5rem 0;

  &:hover {
    background-color: #ffffff;
    box-shadow: rgba(0, 0, 0, 0.1) 0 0 0 1px, rgba(0, 0, 0, 0.1) 0 4px 16px;
  }

  > div {
    align-items: center;
    display: block;
  }

  i {
    box-sizing: content-box;
    color: #5e72e4;
    vertical-align: top;
    font-size: 1.5rem;
  }

  span {
    display: inline-block;
    font-size: 0.875rem;
    line-height: 1.5;
    margin-left: 16px;
    vertical-align: middle;
  }
}

.card-profile-image img {
  width: 180px;
  height: 180px;
  border-radius: 10%;
}
</style>
<style>
p > strong {
  font-weight: bold !important;
}

.tr-container-read-only .quill-editor .ql-container,
.tr-container-read-only .quill-editor .ql-container .ql-editor {
  max-height: 18rem;
  width: 100%;
}

.tr-container-edditable .quill-editor .ql-container,
.tr-container-edditable .quill-editor .ql-container .ql-editor {
  min-height: 11rem;
  width: 100%;
}
</style>
